import script from "./PeopleTagsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleTagsFilter.vue?vue&type=script&setup=true&lang=js"

import "./PeopleTagsFilter.vue?vue&type=style&index=0&id=5ac4525f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac4525f"]])

export default __exports__